export default __webpack_public_path__ + "static/tech-azure-45a8823195aba3d07c50151e21327f86.png";